<template>
  <el-dialog
    v-if="dialogVisible"
    title="监管合同关闭后复制合同提示"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="cancelHandler"
    append-to-body
  >
    <div class="container"> 该合同已关闭,是否复制该合同进行后续操作 </div>
    <div class="btn-group">
      <el-button @click="copyContractHandler">复制合同</el-button>
      <el-button @click="cancelHandler" type="primary">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'CopyDialog',
    data() {
      return {
        dialogVisible: false,
        currentContractId: -1,
      };
    },
    methods: {
      openDialog(currentContractId) {
        this.dialogVisible = true;
        this.currentContractId = currentContractId;
      },
      cancelHandler() {
        this.dialogVisible = false;
        this.$emit('refreshTable');
      },

      // 复制合同
      copyContractHandler() {
        const id = this.currentContractId;
        const path = {
          path: `/park/leaseContract/leaseDetail`,
          name: 'leaseDetail',
          meta: {
            keepAlive: false,
            title: '三方仓库租赁合同维护',
          },
          query: {
            status: 'create',
            id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    text-align: center;
  }
  .btn-group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 30px;
  }
</style>
